import { render, staticRenderFns } from "./ListAnnotationsBy.vue?vue&type=template&id=a8af03cc&scoped=true&"
import script from "./ListAnnotationsBy.vue?vue&type=script&lang=js&"
export * from "./ListAnnotationsBy.vue?vue&type=script&lang=js&"
import style0 from "./ListAnnotationsBy.vue?vue&type=style&index=0&id=a8af03cc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8af03cc",
  null
  
)

export default component.exports